import React from 'react';
import { Redirect } from 'react-router';
import { FormView } from './FormView';

export default function FormViewJoinAsAlysei(props) {
  const currentSearch = props?.location?.search || '';
  const currentPathname = props?.location?.pathname || props?.match?.url || '/';
  const searchParams = new URLSearchParams(currentSearch);

  // If path has no locale prefix (/en or /it), redirect to locale-prefixed version
  // so withLocalization HOC sets localStorage.lang correctly and translation works
  const pathParts = currentPathname.split('/');
  if (pathParts[1] !== 'en' && pathParts[1] !== 'it') {
    const lang = localStorage.getItem('lang') || 'en';
    const locale = (lang === 'it') ? 'it' : 'en';
    if (!searchParams.get('join')) {
      searchParams.set('join', 'alysei');
    }
    return (
      <Redirect
        to={{
          pathname: `/${locale}${currentPathname}`,
          search: `?${searchParams.toString()}`,
          hash: props?.location?.hash || '',
        }}
      />
    );
  }

  if (!searchParams.get('join')) {
    searchParams.set('join', 'alysei');
    return (
      <Redirect
        to={{
          pathname: currentPathname,
          search: `?${searchParams.toString()}`,
          hash: props?.location?.hash || '',
        }}
      />
    );
  }

  const mergedProps = {
    ...props,
    match: {
      ...props.match,
      params: { ...props.match?.params, role: 'italian-food-beverage-producers' },
    },
  };
  return <FormView {...mergedProps} />;
}
